var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import OnboardingService from "@irati/onboarding/services/onboarding";
import OnboardingStep from "@irati/onboarding/enums/Step";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import { connect } from "@irati/store";
import authentication from "@irati/auth";
import { LangLoader, FormattedMessage } from "@irati/utils/lang";
import Button from "@irati/ui/src/Button";
import { ButtonLink } from "@irati/ui/src/Link";
import Close from "@irati/ui/src/Close";
import { greys } from "@irati/ui/src/global/colors";
import Routes, { SETUP_TENANT } from "@irati-web/app/src/routeConfig";
import Flex from "@irati/ui/src/Flex";
import { Para } from "@irati/ui/src/Labels";
import tenantSetupTracking, { ClickedModalValues } from "@irati-tracking/tenant-setup";
import { Wrapper, Notification, CloseWrapper, CenterH1, WelcomeImage, ContentWrapper } from "./styled";
var LEGACY_TENANT_SETUP_HIDE_COOKIE = "hideTenantSetupPrompt";
var FullScreenNotification = /** @class */ (function (_super) {
    __extends(FullScreenNotification, _super);
    function FullScreenNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showNotification: false,
            load: hangPromise()
        };
        _this.componentDidMount = function () {
            var promises = [OnboardingService.getTenantOnboarding()];
            if (!authentication.isUserGhost()) {
                promises.push(OnboardingService.get(authentication.user().uuid));
            }
            var load = Promise.all(promises).then(function (_a) {
                var tenantOnboarding = _a[0], userOnboarding = _a[1];
                // Moved from LocalStorage -> graph (Feb-2020), check kept to avoid double tours
                var seenModalPreviously = authentication.isUserGhost() ||
                    userOnboarding.completedSteps.includes(OnboardingStep.HAS_VIEWED_TENANT_SETUP_PRE_TOUR);
                var modalViewable = (tenantOnboarding === null || tenantOnboarding === void 0 ? void 0 : tenantOnboarding.enabled) && !tenantOnboarding.onboardingFinished;
                if (modalViewable && _this.shouldShowNotification() && !seenModalPreviously) {
                    // If the service thinks the user should see the tour but they have the LocalStorage value, fire an update
                    if (localStorage.getItem(LEGACY_TENANT_SETUP_HIDE_COOKIE)) {
                        _this.neverShowWelcomeAgain();
                    }
                    else {
                        tenantSetupTracking.viewSetupModal();
                        _this.setState({ showNotification: true });
                    }
                }
            });
            _this.setState({ load: load });
        };
        _this.shouldShowNotification = function () {
            var isMobile = _this.props.isMobile;
            var _a = _this.context, apps = _a.apps, appPath = _a.appPath;
            var isAdmin = authentication.isGlobalAdmin();
            var isHome = appPath === apps.HOME;
            return isAdmin && !isMobile && isHome;
        };
        _this.neverShowWelcomeAgain = function () { return OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_VIEWED_TENANT_SETUP_PRE_TOUR); };
        _this.onHideNotification = function (clickedElement) {
            _this.setState({ showNotification: false });
            _this.neverShowWelcomeAgain();
            tenantSetupTracking.clickSetupModal({ clicked: clickedElement });
        };
        return _this;
    }
    FullScreenNotification.prototype.render = function () {
        var _this = this;
        var _a = this.state, load = _a.load, showNotification = _a.showNotification;
        if (!showNotification) {
            return null;
        }
        return (React.createElement(LangLoader, { bucket: SETUP_TENANT },
            React.createElement(Loading, { load: load },
                React.createElement(Wrapper, null,
                    React.createElement(Notification, null,
                        React.createElement(CloseWrapper, null,
                            React.createElement(Close, { onClick: function () { return _this.onHideNotification(ClickedModalValues.Cross); }, color: greys.mediumDark, top: "20px", right: "20px" })),
                        React.createElement(WelcomeImage, null),
                        React.createElement(ContentWrapper, null,
                            React.createElement(CenterH1, { base: true },
                                React.createElement(FormattedMessage, { id: "setup_tenant.fullScreenModal.title.main" })),
                            React.createElement(Para, { large: true, center: true },
                                React.createElement(FormattedMessage, { id: "setup_tenant.fullScreenModal.title.sub" })),
                            React.createElement(Flex, { alignItems: "center", justifyContent: "space-around", margin: "30px 0 0 0", width: "100%" },
                                React.createElement(Button, { large: true, onClick: function () { return _this.onHideNotification(ClickedModalValues.Dolater); } },
                                    React.createElement(FormattedMessage, { id: "setup_tenant.fullScreenModal.buttons.later" })),
                                React.createElement(ButtonLink, { onClick: function () { return _this.onHideNotification(ClickedModalValues.Letsgo); }, large: true, primary: true, href: Routes[SETUP_TENANT] },
                                    React.createElement(FormattedMessage, { id: "setup_tenant.fullScreenModal.buttons.start" })))))))));
    };
    FullScreenNotification.contextTypes = {
        apps: PropTypes.object.isRequired,
        appPath: PropTypes.string.isRequired
    };
    return FullScreenNotification;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({ isMobile: mq.lessThan.sm });
};
export default connect(mapStateToProps)(FullScreenNotification);
